Pegasus.PrettySelect = Ember.ContainerView.extend({
  classNames: ['pretty-select-view'],
  childViews: ['select'],

  optionLabelPath: 'content',

  onSelectionChange: null,

  triggerChangeEvent: function(){
    Em.run.scheduleOnce('afterRender', this, function(){
      this.get('parentView').send(this.get('onSelectionChange'));
    });
  },

  select: Ember.Select.extend({
    classNames: ['pretty-select'],
    contentBinding: 'parentView.content',
    classNameBindings: ['hasErrors:error'],
    valueBinding: 'parentView.value',
    promptTranslationBinding: 'parentView.promptTranslation',

    optionLabelPathBinding: 'parentView.optionLabelPath',

    prompt: function(){
      if ( this.get('promptTranslation') ) {
        return Em.I18n.t( this.get('promptTranslation') );
      }
      return null;//Em.I18n.t('g.select_default_prompt');
    }.property('promptTranslation'),

    didInsertElement: function(){
      this._super();
      Em.run.scheduleOnce('afterRender', this, 'bindSelects');
    },

    bindSelects: function(){
      var view = this;

      /*
      Reference: http://jsfiddle.net/BB3JK/47/
      */

      var $this = this.$(),
        numberOfOptions = $this.children('option').length;

      $this.addClass('select-hidden');
      $this.wrap('<div class="select"></div>');
      $this.after('<div class="select-styled"></div>');

      var $styledSelect = $this.next('div.select-styled');

      var initialPath = 'value';

      if ( this.get('optionLabelPath') !== 'content' ) {
        initialPath += this.get('optionLabelPath').replace(/^content/, '');
      }

      var initial = this.get(initialPath) ||
        /* this should be the prompt text */
        $this.children('option').eq(0).text();

      $styledSelect.text(initial);
      $styledSelect.attr('rel', initial);

      var $list = $('<ul />', {
        'class': 'select-options'
      }).insertAfter($styledSelect);

      for (var i = 0; i < numberOfOptions; i += 1) {
        $('<li />', {
            text: $this.children('option').eq(i).text(),
            rel: $this.children('option').eq(i).val()
        }).appendTo($list);
      }

      var $listItems = $list.children('li');

      $styledSelect.click(function(e) {
        e.stopPropagation();
        $('div.select-styled.active').each(function(){
            $(this).removeClass('active').next('ul.select-options').hide();
        });
        $(this).toggleClass('active').next('ul.select-options').toggle();
      });

      $listItems.click(function(e) {
        var index = $list.children().index( e.target );

        e.stopPropagation();
        $styledSelect.text($(this).text()).removeClass('active');
        $styledSelect.attr('rel', $(this).attr('rel'));
        $this.val($(this).attr('rel'));
        $list.hide();
        index = view.get('promptTranslation') ? index - 1 : index;
        Em.run(function(){
        if(view.get('parentView.onSelectionChange') && view.get('value') != view.get('content').objectAt(index)){
            view.get('parentView').send('triggerChangeEvent');
          }
          view.set('value', view.get('content').objectAt(index) || '');
        });
      });

      $(document).click(function() {
        $styledSelect.removeClass('active');
        $list.hide();
      });
    }
  })
});

Handlebars.registerHelper('PrettySelect', function(options) {
  return Ember.Handlebars.ViewHelper.helper(this, Pegasus.PrettySelect, options);
});

Pegasus.PrettySelectFonts = Pegasus.PrettySelect.extend({
  classNames: ['pretty-select-view'],
  childViews: ['select'],

  optionLabelPath: 'content',

  select: Ember.Select.extend({
    classNames: ['pretty-select'],
    contentBinding: 'parentView.content',
    valueBinding: 'parentView.value',
    classNameBindings: ['hasErrors:error'],

    promptTranslationBinding: 'parentView.promptTranslation',
    optionLabelPathBinding: 'parentView.optionLabelPath',

    prompt: function(){
      if ( this.get('promptTranslation') ) {
        return Em.I18n.t( this.get('promptTranslation') );
      }
      return null;
    }.property('promptTranslation'),

    didInsertElement: function(){
      this._super();
      Em.run.scheduleOnce('afterRender', this, 'bindSelects');
    },

    bindSelects: function(){
      var view = this;

      /*
      Reference: http://jsfiddle.net/BB3JK/47/
      */
      var $this = this.$(),
        numberOfOptions = $this.children('option').length;

      $this.addClass('select-hidden');
      $this.wrap('<div class="select"></div>');
      $this.after('<div class="select-styled"></div>');

      var $styledSelect = $this.next('div.select-styled');

      var initialPath = 'value';

      if ( this.get('optionLabelPath') !== 'content' ) {
        initialPath += this.get('optionLabelPath').replace(/^content/, '');
      }

      var initial = this.get(initialPath) ||
        /* this should be the prompt text */
        $this.children('option').eq(0).text();

      $styledSelect.text(initial.split(',')[0]);
      $styledSelect.css("font-family", initial);
      $styledSelect.attr('rel', initial);

      var $list = $('<ul />', {
        'class': 'select-options'
      }).insertAfter($styledSelect);


      for (var i = 0; i < numberOfOptions; i += 1) {
        $('<li />', {
          text: $this.children('option').eq(i).text().split(',')[0],
          rel: $this.children('option').eq(i).val(),
          style: 'font-family:'+$this.children('option').eq(i).text()+';'
        }).appendTo($list);
      }
      var $listItems = $list.children('li');

      $styledSelect.click(function(e) {
        e.stopPropagation();
        $('div.select-styled.active').each(function(){
          $(this).removeClass('active').next('ul.select-options').hide();
        });
        $(this).toggleClass('active').next('ul.select-options').toggle();
      });

      $listItems.click(function(e) {
        e.stopPropagation();
        $styledSelect.text($(this).text()).removeClass('active');
        $styledSelect.attr('rel', $(this).attr('rel'));
        $styledSelect.css("font-family", $(this).attr('rel'));
        $this.val($(this).attr('rel'));
        $list.hide();

        Em.run( view, 'set', 'value', $(this).attr('rel') );

      });

      $(document).click(function() {
        $styledSelect.removeClass('active');
        $list.hide();
      });
    }
  })
});

Handlebars.registerHelper('PrettySelectFonts', function(options) {
  return Ember.Handlebars.ViewHelper.helper(this, Pegasus.PrettySelectFonts, options);
});